import React, { useState } from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import '../../Assets/css/footer.css';
import BwLogo from '../../Assets/images/white-logo.png';
import { Link, NavLink } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material/';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import rapnet from '../../Assets/images/home/rapnet.webp';
import overnight from '../../Assets/images/home/overnight-logo.webp';
import vdb from '../../Assets/images/home/vdb.webp';
import ivouch from '../../Assets/images/home/ivouch.webp';
import yelp from '../../Assets/images/home/yelp-logo.webp';
import google from '../../Assets/images/home/google.webp';
import paypal from '../../Assets/images/home/paypal.webp';
import { Address_details, Email_details, Email_detailsSecond, client_name, contact_number, media_details } from '../../Helpers/request';
import { isDesktop } from 'react-device-detect';
import Brands from "../Front/orloff/orloff-assets/orloff-images/brands.png"
import Call from "../Front/orloff/orloff-assets/orloff-images/Call.png"
import Location from "../Front/orloff/orloff-assets/orloff-images/Location.png"
import Message from "../Front/orloff/orloff-assets/orloff-images/Message.png"

const Footer = () => {

  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <div className="rcs_footer" id="rcs_footer">
        <Container fluid className="showcase-container rcs_custom_home_container">
          <div className='d-none d-lg-block'>
            <Row className='justify-content-between'>
              <Col xs={12} sm={6} md={12} lg={4}>
                <div className='rcs_footer_content_one '>
                  <div className="logo">
                    <NavLink to="/">
                      Orloff Of Denmark
                      {/* <Image height='60' style={{marginLeft:'-6px'}} src={BwLogo} alt={client_name.c_name} /> */}
                    </NavLink>
                  </div>
                  <p>Orloff of Denmark is a registered trademark in the USA, European Union, India, and China. Our brand and our commitment to quality are protected globally... <NavLink to="/our-story">Read More</NavLink></p>
                </div>
                <div className="rcs_footer_content_one_social_icn">
                  <ul >
                    {
                      media_details.map((media, id) =>
                        <li key={id}>
                          <div className="rcs_footer_content_one_social_icn_div">
                            <a href={media.account_link} target="_blank"  >{media.account_icon}</a>
                          </div>
                        </li>
                      )}
                    {/* <li>
                      <div className="rcs_footer_content_one_social_icn_div">
                        <a href="https://twitter.com/belgiumwebnet" target="_blank" >   <RiTwitterFill /> </a>
                      </div>
                    </li>
                    <li>
                      <div className="rcs_footer_content_one_social_icn_div">
                        <a href="https://www.instagram.com/belgium_webnet/" target="_blank" >    <RiInstagramLine /> </a>
                      </div>
                    </li>
                    <li>
                      <div className="rcs_footer_content_one_social_icn_div">
                        <a href="https://www.linkedin.com/company/belgium-webnet/" target="_blank" >  <RiLinkedinBoxFill /> </a>
                      </div>
                    </li> */}
                  </ul>
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={2}>
                <div className='rcs_footer_content rcs_info'>
                  <h2 className='mb-3'>Information</h2>
                  <ul className='rcs_footer_list'>
                    {/* <li><NavLink to="/our-story">Our Story</NavLink></li> */}
                    <li><NavLink to="/our-story">About Us</NavLink></li>
                    <li><NavLink to="/contact">Contact Us</NavLink></li>
                    {/* <li><NavLink to="/education">Education</NavLink></li> */}
                    <li><NavLink to="/privacy-policy">Privacy Policy</NavLink></li>
                    <li><NavLink to="/returns-and-exchanges">Return Policy</NavLink></li>
                    <li><NavLink to="/terms-and-conditions">Terms & Condition</NavLink></li>
                    <li><NavLink to="/make-an-appointment">Virtual Appointment</NavLink></li>
                  </ul>
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={2}>
                <div className='rcs_footer_content rcs_info'>
                  <h2 className='mb-3'>Collection</h2>
                  <ul className='rcs_footer_list'>
                    <li><NavLink to="/jewelry/fashion-rings">Rings</NavLink></li>
                    <li><NavLink to="/jewelry/necklaces">Necklaces</NavLink></li>
                    <li><NavLink to="/jewelry/earrings">Earrings</NavLink></li>
                    <li><NavLink to="/jewelry/pendants">Pendants</NavLink></li>
                    <li><NavLink to="/jewelry/bracelets">Bracelets</NavLink></li>
                  </ul>
                </div>
              </Col>

              <Col xs={12} sm={6} md={6} lg={2} className='d-flex justify-content-end'>
                <div className='rcs_footer_content'>
                  <h2 className='mb-3'>Get in Touch</h2>
                  <ul className="rcs_footer_list">
                    {/* <p className='mt-0'>Address: </p> */}
                    {/* <li style={{alignItems: "flex-start"}} onClick={() => { window.open(Address_details.link, '_blank') }}>
                      <Image src={Location} alt='' />
                      {Address_details.textLine1}
                      <br />
                      {Address_details.textLine2}
                    </li> */}

                    <li onClick={(e) => { window.location.href = contact_number.link }}>
                      <a href={`${contact_number.link}`} style={{color: "#fff"}}>
                        <Image src={Call} alt='' />
                        {contact_number.text}
                      </a>

                    </li>

                    <li onClick={(e) => { window.location.href = Email_details.link }}>
                      <Image src={Message} alt='' /> {Email_details.text}
                    </li>

                    <li onClick={(e) => { window.location.href = Email_detailsSecond.link }}>
                      <Image src={Message} alt='' />
                      {Email_detailsSecond.text}
                    </li>
                  </ul>

                </div>
              </Col>

              <Col lg={12}>
                <div className='pt-5 pb-4 text-center'>
                  <Image src={Brands} alt='' />
                </div>
              </Col>

              {/* <Col xs={12} sm={6} md={6} lg={2}>
                <div className='rcs_footer_content'>
                  <h2 className='mb-3'>Help</h2>
                  <ul className='rcs_footer_list'>
                    <li><NavLink to="/faq">FAQ’s</NavLink></li>
                    <li><NavLink to="/contact">Contact Us</NavLink></li>
                  </ul>
                </div>
              </Col> */}
            </Row>


          </div>
        </Container>
      </div>
      <section className="d-lg-none d-md-block rcs_mobile_footer_section">
        <Container>
          <div className="gs_footer_content d-lg-none d-md-block  ">
            <Row className="m-0 w-100">
              <Col xs={12}>
                <div className='rcs_footer_content_one '>
                  <div className="logo">
                    <NavLink to="/">
                      Orloff Of Denmark
                      {/* <Image height='52' src={BwLogo} alt={client_name.c_name} /> */}
                    </NavLink>
                  </div>
                  <p>At {client_name.c_name}, we aim to be more than just your jeweler; we strive to be the cherished link in the chain of your family's memories. With a deep appreciation for the traditions of the past and a keen focus on the future... <br /><Link to='/our-story'>Read More</Link></p>
                </div>
                <div className="rcs_footer_content_one_social_icn">
                  <ul>
                    {
                      media_details.map((media) =>
                        <li>
                          <div className="rcs_footer_content_one_social_icn_div">
                            <a href={media.account_link} target='_blank' rel="noreferrer">{media.account_icon}</a>
                          </div>
                        </li>
                      )}
                  </ul>
                </div>
              </Col>
              <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                  className="rcs_footer_t_color_white"
                >
                  <span className='footer-mobile-heading'>Information</span>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <div className="block-footer3">
                      <ul className='rcs_footer_list contact-foter2'>
                        <li><NavLink to="/our-story">Our Story</NavLink></li>
                        {/* <li><NavLink to="/our-story">About Us</NavLink></li> */}
                        {/* <li><NavLink to="/blog">Blog</NavLink></li> */}
                        {/* <li><NavLink to="/education">Education</NavLink></li> */}
                        <li><NavLink to="/privacy-policy">Privacy Policy</NavLink></li>
                        <li><NavLink to="/returns-and-exchanges">Return Policy</NavLink></li>
                        <li><NavLink to="/terms-and-conditions">Terms & Condition</NavLink></li>
                        <li><NavLink to="/make-an-appointment">Virtual Appointment</NavLink></li>
                      </ul>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                  className="rcs_footer_t_color_white"
                >
                  <span className='footer-mobile-heading'>Collection</span>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <div className="block-footer3">
                      <ul className='rcs_footer_list contact-foter2'>
                        <li><NavLink to="/jewelry/fashion-rings">Rings</NavLink></li>
                        <li><NavLink to="/jewelry/necklaces">Necklaces</NavLink></li>
                        <li><NavLink to="/jewelry/earrings">Earrings</NavLink></li>
                        <li><NavLink to="/jewelry/pendants">Pendants</NavLink></li>
                        <li><NavLink to="/jewelry/bracelets">Bracelets</NavLink></li>
                      </ul>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4bh-content"
                  id="panel4bh-header"
                  className="rcs_footer_t_color_white"
                >
                  <span className='footer-mobile-heading'>Get in Touch</span>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <div className="block-footer3">
                      <ul className="list-none contact-foter2">
                        {/* <p className='mt-0'>Address: </p> */}
                        <li onClick={() => { window.open(Address_details.link, '_blank') }}>

                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.91699 8.59797C2.91699 4.76475 6.12023 1.6665 9.99486 1.6665C13.8804 1.6665 17.0837 4.76475 17.0837 8.59797C17.0837 10.5296 16.3812 12.3229 15.2249 13.8428C13.9493 15.5194 12.3771 16.9802 10.6074 18.1269C10.2024 18.3919 9.83689 18.4118 9.39237 18.1269C7.61261 16.9802 6.0404 15.5194 4.77574 13.8428C3.61865 12.3229 2.91699 10.5296 2.91699 8.59797ZM7.66218 8.8138C7.66218 10.0979 8.71004 11.1079 9.99486 11.1079C11.2805 11.1079 12.3385 10.0979 12.3385 8.8138C12.3385 7.53967 11.2805 6.48053 9.99486 6.48053C8.71004 6.48053 7.66218 7.53967 7.66218 8.8138Z" fill="#F9F0F0" />
                          </svg>
                          {Address_details.textLine1}
                          <br />
                          {Address_details.textLine2}
                        </li>

                        <li>
                          <a href={`${contact_number.link}`} className='colorWhite'>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.60946 10.3933C12.9337 13.7166 13.6878 9.87194 15.8044 11.987C17.8449 14.027 19.0177 14.4357 16.4324 17.0203C16.1085 17.2805 14.051 20.4116 6.82018 13.1827C-0.411557 5.95301 2.71766 3.89338 2.97798 3.56963C5.56956 0.977879 5.97123 2.15749 8.01175 4.19745C10.1283 6.31342 6.28522 7.07002 9.60946 10.3933Z" fill="#F7F2F5" />
                            </svg>

                            {contact_number.text}
                          </a>
                        </li>
                        <li className="pb-1" onClick={(e) => { window.location.href = Email_details.link }}>

                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1162 2.5C15.2337 2.5 16.3087 2.94167 17.0995 3.73417C17.8912 4.525 18.3337 5.59167 18.3337 6.70833V13.2917C18.3337 15.6167 16.442 17.5 14.1162 17.5H5.88366C3.55783 17.5 1.66699 15.6167 1.66699 13.2917V6.70833C1.66699 4.38333 3.54949 2.5 5.88366 2.5H14.1162ZM15.442 7.95L15.5087 7.88333C15.7078 7.64167 15.7078 7.29167 15.4995 7.05C15.3837 6.92583 15.2245 6.85 15.0587 6.83333C14.8837 6.82417 14.717 6.88333 14.5912 7L10.8337 10C10.3503 10.4008 9.65783 10.4008 9.16699 10L5.41699 7C5.15783 6.80833 4.79949 6.83333 4.58366 7.05833C4.35866 7.28333 4.33366 7.64167 4.52449 7.89167L4.63366 8L8.42533 10.9583C8.89199 11.325 9.45783 11.525 10.0503 11.525C10.6412 11.525 11.217 11.325 11.6828 10.9583L15.442 7.95Z" fill="#F7F2F5" />
                          </svg>
                          {Email_details.text}</li>
                        <li onClick={(e) => { window.location.href = Email_detailsSecond.link }}>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1162 2.5C15.2337 2.5 16.3087 2.94167 17.0995 3.73417C17.8912 4.525 18.3337 5.59167 18.3337 6.70833V13.2917C18.3337 15.6167 16.442 17.5 14.1162 17.5H5.88366C3.55783 17.5 1.66699 15.6167 1.66699 13.2917V6.70833C1.66699 4.38333 3.54949 2.5 5.88366 2.5H14.1162ZM15.442 7.95L15.5087 7.88333C15.7078 7.64167 15.7078 7.29167 15.4995 7.05C15.3837 6.92583 15.2245 6.85 15.0587 6.83333C14.8837 6.82417 14.717 6.88333 14.5912 7L10.8337 10C10.3503 10.4008 9.65783 10.4008 9.16699 10L5.41699 7C5.15783 6.80833 4.79949 6.83333 4.58366 7.05833C4.35866 7.28333 4.33366 7.64167 4.52449 7.89167L4.63366 8L8.42533 10.9583C8.89199 11.325 9.45783 11.525 10.0503 11.525C10.6412 11.525 11.217 11.325 11.6828 10.9583L15.442 7.95Z" fill="#F7F2F5" />
                          </svg>
                          {Email_detailsSecond.text}</li>
                      </ul>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4bh-content"
                  id="panel4bh-header"
                  className="rcs_footer_t_color_white"
                >
                  <span className='footer-mobile-heading'>Help</span>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <div className="block-footer3">
                      <ul className='rcs_footer_list contact-foter2'>
                        <li><NavLink to="/faq">FAQ’s</NavLink></li>
                        <li><NavLink to="/contact">Contact Us</NavLink></li>
                      </ul>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion> */}

              <Col lg={12}>
                <div className='pt-4 pb-4 text-center'>
                  <Image src={Brands} alt='' />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      {isDesktop ?
        <div className='rcs_footer_bottom' id="rcs_footer_bottom">
          <Container className="showcase-container rcs_custom_home_container">
            <Row className='w-100 m-auto justify-content-center'>
              <Col lg={12} md={12} className='p-0'>
                <div className='rcs_footer_bottom_content'>
                  <p className='m-0'>  Copyright © {new Date().getFullYear()} {client_name.c_name} All rights reserved.</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        :
        // Mobile footer
        <div className='rcs_footer_bottom' id="rcs_footer_bottom">
          <div className="showcase-container rcs_custom_home_container">
            <Row className='w-100 m-auto justify-content-center'>

              {/* <Col lg={4} md={4}>
              <ul className='d-flex justify-content-center align-items-center'>
                {
                  media_details.map((media, id) =>
                    <li key={id} className='mr-2'>
                      <div className="rcs_footer_content_one_social_icn_div">
                        <a href={media.account_link} target="_blank"  >{media.account_icon}</a>
                      </div>
                    </li>
                  )}
              </ul>
            </Col> */}
              <Col lg={12} md={12} className='p-0'>
                <div className='rcs_footer_bottom_content'>
                  <p className='m-0'>  Copyright © {new Date().getFullYear()} {client_name.c_name} All rights reserved.</p>
                </div>
              </Col>
            </Row>
          </div>
        </div>}
      {/* Whatsapp Chat */}
      {/* <a href="https://wa.me/+16469929024" class="whatsapp_float" target="_blank" rel="noopener noreferrer">
        <Image src={whatsapp} alt="whatspp chat"></Image>
      </a> */}
      {/* Whatsapp Chat */}
      {/* <div className='rcs_footer_chat'>
        <div className='rcs_diamond_specialist'>

        </div>
        <div className='rcs_diamond_tdo_chat'>

        </div>
      </div> */}
    </>
  )
}
export default Footer;